import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { setReturningVisitorFlag } from '../lib/returningVisitor'

const BASE = import.meta.env.VITE_API_URL ?? ''

export default function AuthCompletePage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const fetchUser = useAuthStore((s) => s.fetchUser)

  useEffect(() => {
    const code = params.get('code')
    if (!code) {
      navigate('/auth/error?reason=oauth_failed', { replace: true })
      return
    }

    async function exchange() {
      try {
        const res = await fetch(`${BASE}/auth/session`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code }),
        })
        if (!res.ok) {
          navigate('/auth/error?reason=oauth_failed', { replace: true })
          return
        }
        await fetchUser()
        setReturningVisitorFlag()
        const user = useAuthStore.getState().user
        if (user?.onboardingCompleted) {
          navigate('/home', { replace: true })
        } else {
          navigate('/onboarding', { replace: true })
        }
      } catch {
        navigate('/auth/error?reason=oauth_failed', { replace: true })
      }
    }

    exchange()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center">
      <p className="text-stone-500 text-sm">Signing you in…</p>
    </div>
  )
}
